import * as React from 'react';
var syllable = require('syllable');

const LINE_HEIGHT = 16;
let possibleStarts: Array<string> = [
  "A New York nine's an everywhere else six\nTime-wise, the opposite goes for chicks\nI'm in a taxi, texting with my best friend\nHe's sleeping with this girl that he met up on West End\nHe's lucky, she's a career woman, no kids\nMost girls see the clothes and try and gold dig\nMost hoes poke holes in Trojans\n",
  "We 'bout to feed these youngin's to the metaverse\nMeanwhile I'm over here just tryna pen a verse\n'Cause I'm done bein' extra with the extroverts\nThe label used to wonder how I'm supposed to stand next to Vert\nProlly never thought that I would get these legs to work\n",
  "His palms are sweaty, knees weak, arms are heavy\nThere's vomit on his sweater already, mom's spaghetti\nHe's nervous, but on the surface he looks calm and ready to drop bombs\nBut he keeps on forgetting what he wrote down\nThe whole crowd goes so loud\nHe opens his mouth, but the words won't come out\nHe's choking how, everybody's joking now\n"
]
var index = Math.floor(Math.random()*possibleStarts.length);
const startString:string = possibleStarts[index];

interface IProps {
  onInput?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onKeyUp?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  onClick?: (e: React.MouseEvent<HTMLTextAreaElement>) => void;
  currentLine?: number;
}

interface IState {
  charCount: number;
  currentLine: number;
  comparisonLine: number;
  compWordIdx: [number, number];
  compareWord: string;
  rhymeList: string;
  nearRhymeList: string;
  aiRhymeList: string;
  aiNextLine: string;
  value: string;
  syllableCounts: Array<number>;
  loadingAILine: boolean;
  loadingAIRhyme: boolean;
}

interface Rhyme {
    word: string;
    score: number;
    syllables: number;
}

const Scribe: React.FunctionComponent<IProps> = (props: IProps) => {
    return <textarea defaultValue={startString} {...props}/>;
};

class Rap extends React.Component<IProps, IState> {
  public static defaultProps: Partial<IProps> = {};

  public state: IState = {
    charCount: 0,
    currentLine: 0,
    comparisonLine: 0,
    compWordIdx: [-1, -1],
    compareWord: '',
    rhymeList: '',
    nearRhymeList: '',
    aiRhymeList: '',
    aiNextLine: '',
    value: "",
    syllableCounts: [0],
    loadingAIRhyme: false,
    loadingAILine: false
  };

  componentDidMount(){
    this.setState({value: startString})
    this.setState({syllableCounts: this.parseSyllables(startString)});
    this.setState({charCount: startString.length });
    this.handleCursorChange(startString.length, startString); 
  }

  public findLineNumber = (charPos: number, rapString: string) => {
  	var linesPassed = 0
  	for (let i = 0; i < charPos; i++) {
		const character = rapString.charAt(i);
		if (character === '\n'){
			linesPassed += 1;
	  	}
	}
  	return linesPassed;
  }

  public findWord = (compareLine: number, rapString: string): [string, [number,number]] => {
    var stripRegEx = /[^0-9a-z]/gi;
    var lines = rapString.split('\n');
    var compareIdx = 0;

    // Count up characters to get to end of compareLine
    for (let a = 0; a <= compareLine; a++){
        compareIdx += lines[a].length+1;
    }

    var splitLine = lines[compareLine].split(' ');
    var trav = 0

    for (let i = splitLine.length; i > 0; i--){
      trav += splitLine[i-1].length+1;
      var word = splitLine[i-1].replace(stripRegEx, '')
      if(word !== ''){
        // Subtract the end of the line from counta
        return [word, [compareIdx - trav, compareIdx]];
      }
    }
    return ['---', [-1, -1]];
  }

  public processRhymeResponse = (msg: string, queryType: string) => {
    let rhymeList: string = '';
    var rhymes = msg as unknown as Array<Rhyme>;
    for (let i = 0; i < rhymes.length; i++){
      rhymeList += rhymes[i].word + ', ';
    }

    if (queryType === 'rel_rhy'){
      this.setState({rhymeList: rhymeList});
    } else if (queryType === 'rel_nry'){
      this.setState({nearRhymeList: rhymeList});
    } else {

    }
  }

  public processAIRhymeResponse = (msg: string) => {
    //parse
    this.setState({aiRhymeList: msg});
    this.setState({loadingAIRhyme: false});
  }

  public processAILinesResponse = (msg: string) => {
    //parse
    this.setState({aiNextLine: msg});
    this.setState({loadingAILine: false});
  }

  public setRhymes = (word: string, queryType:string) => {
    var newQueryString: string = "/.netlify/functions/rhymes?word=" + word + "&type=" + queryType;
    fetch(newQueryString, { headers: { accept: "Accept: application/json" } })
    .then((x) => x.json())
    .then(({ msg }) => 
      this.processRhymeResponse(msg, queryType)
    );  
  }

   public setAIRhymes = (word: string) => {
    var newQueryString: string = "/.netlify/functions/ai-rhymes?word=" + word;
    this.setState({loadingAIRhyme: true});
    fetch(newQueryString, { headers: { accept: "Accept: application/json" } })
    .then((x) => x.json())
    .then(({ msg }) => 
      this.processAIRhymeResponse(msg)
    );  
  }

   public setAILines = (rap: string) => {
    var artists: string = "Kanye West, Drake, Jack Harlow, Eminem, and Childish Gambino"
    var newQueryString: string = "/.netlify/functions/ai-lines?rap=" + rap + "&artist=" + artists;
    this.setState({loadingAILine: true});
    fetch(newQueryString, { headers: { accept: "Accept: application/json" } })
    .then((x) => x.json())
    .then(({ msg }) => 
      this.processAILinesResponse(msg)
    );  
  }

  public handleCursorChange = (charPos: number, rapString: string) => {
    var currLine = this.findLineNumber(charPos, rapString);

    if (currLine !== this.state.currentLine) {
      var compareLine = 0;
       if (currLine > 0) { compareLine = currLine -1 };

       var result = this.findWord(compareLine, rapString);
       var compareWord: string = result[0];
       var compareIdx: [number, number] = result[1];

       if (compareWord !== this.state.compareWord){
         this.setRhymes(compareWord, 'rel_rhy');
         this.setRhymes(compareWord, 'rel_nry');
         this.setAIRhymes(compareWord);
       }

       this.setAILines(rapString.substring(0, compareIdx[1])); 
       this.setState({comparisonLine: compareLine});
       this.setState({compWordIdx: compareIdx});
       this.setState({compareWord:compareWord});
    }
     
     this.setState({currentLine: currLine});
  }

  public parseSyllables = (rapString: string) => {
    var counts: Array<number> = [];
    var currLine = 0;
    var currCharIdx = 0;

    for (let i = 0; i < rapString.length; i++) {
      const character = rapString.charAt(i);
      if (character === '\n'){
        counts[currLine] = syllable(rapString.substring(currCharIdx,i));
        currLine += 1;
        currCharIdx = i;
      }
    }
    
    counts[currLine] = syllable(rapString.substring(currCharIdx, rapString.length));

    return counts;
  }

  public textChanged = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const charCount = event.target.value.length;
    const newCounts = this.parseSyllables(event.target.value);

    this.setState({syllableCounts: newCounts});
    this.setState({charCount: charCount });

    this.setState({value: event.target.value});
    event.target.style.height = (newCounts.length) * LINE_HEIGHT + "px";
  };

  public clickChanged = (event: React.MouseEvent<HTMLTextAreaElement>) => {
    const charPos = event.currentTarget.selectionEnd;
    const rapString = event.currentTarget.value;
    this.handleCursorChange(charPos, rapString); 
  };

  public keyChanged = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    const charPos = event.currentTarget.selectionEnd;
    const rapString = event.currentTarget.value;
    this.handleCursorChange(charPos, rapString);    
  };

  public upgrade = (rap: string) => {
    var repl = '<span id=highlight>' + this.state.compareWord + '</span>';
    var re = new RegExp(this.state.compareWord,"g");
    var newRap = rap.replace(re, (input, offset) => {
        if (offset >= this.state.compWordIdx[0] && offset <= this.state.compWordIdx[1]){
            return repl;
        } else {
            return this.state.compareWord;
        }
    });
    return newRap;
  };

  public render() {
    const upgradedValue = this.upgrade(this.state.value);
    const dynamicTop = (this.state.comparisonLine+1)*LINE_HEIGHT;
    const isAIRhymesLoading = this.state.loadingAIRhyme;
    const isAILinesLoading = this.state.loadingAILine;

    var syllableString: string = '';
    
    for (let i = 0; i < this.state.syllableCounts.length; i++){
      if (this.state.syllableCounts[i] === 0){
        syllableString += '\n';
      } else {
        syllableString += String(this.state.syllableCounts[i]) + '\n';
      }
    }

    var aiLines = this.state.aiNextLine.split(/\r?\n/);

    return (
      <div id = 'workspace'>
        <div id='editor'> <b>Text editor</b> 
          <Scribe onKeyUp={ e => this.keyChanged(e) } onInput={ e => this.textChanged(e) } onClick={ e => this.clickChanged(e)} />
          <pre
            aria-hidden="true"
            {...(true 
                ? {dangerouslySetInnerHTML: { __html: upgradedValue}}
                : {dangerouslySetInnerHTML: { __html: upgradedValue}}
                )
            }
          />
          <div id="ai-next-line"><b>AI Line Suggestions</b> { !isAILinesLoading ?  aiLines.map((line)=>{return (<p>{line}</p>)}) : "loading" }</div>
          <pre id="syllable-count">{syllableString}</pre>  
        </div>
          <div id="rhymes"> <div id="rhymes-title"><b>Rhyme Suggestions</b></div>
          	<div id="rhyme-box" style={{top: dynamicTop}}>Good: <span id='highlight'> {this.state.rhymeList} </span> </div>
            <div id="rhyme-box-2" style={{top: dynamicTop}}>Close: <span id='highlight'> {this.state.nearRhymeList} </span></div>
            <div id="rhyme-box-3" style={{top: dynamicTop}}>AI: { !isAIRhymesLoading ? <span id='highlight'> {this.state.aiRhymeList} </span> : "loading"}</div>
          </div>
          
          
      </div>
    );
  }
}

export default Rap;